module.exports = __webpack_public_path__ + "img/17.ae92d385.png";